var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",class:_vm.homepageClass},[_c('register-sub-navigation'),_c('transition',[_c('div',[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }